const UI_SHOW_PRELOADER = 'UI_SHOW_PRELOADER';
const UI_HIDE_PRELOADER = 'UI_HIDE_PRELOADER';
const DRAWER_TRIGGER = 'DRAWER_TRIGGER';

// actions
export const uiShowPreLoader = () => ({
  type: UI_SHOW_PRELOADER
});

export const uiHidePreLoader = () => ({
  type: UI_HIDE_PRELOADER
});

export const uiTriggerDrawer = value => ({
  type: DRAWER_TRIGGER,
  payload: value
});

// store
const initialState = {
  showPreLoader: false,
  isOpenDrawer: false
};

// reducer
const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case UI_SHOW_PRELOADER: {
      if (!state.showPreLoader) {
        return { ...state, showPreLoader: true };
      }
      return { ...state };
    }
    case UI_HIDE_PRELOADER: {
      if (state.showPreLoader) {
        return { ...state, showPreLoader: false };
      }
      return { ...state };
    }
    case DRAWER_TRIGGER: {
      return { ...state, isOpenDrawer: action.payload || !state.isOpenDrawer };
    }
    default:
      return state;
  }
};

export default uiReducer;
